export const TO_INVENTORY = 'TO_INVENTORY';
